import React from 'react';
import { Container } from '@mui/material';
import WorkflowTab from '../components/settings/WorkflowTab';

const WorkflowsPage = () => {
  return (
    <Container maxWidth="lg" sx={{
      backgroundColor: "white",
      boxShadow: "0px 4px 16px rgba(0,0,0,0.013)",
      padding: "32px 24px",
      marginBottom: 8,
      marginTop: 2,
    }}>
      <WorkflowTab />
    </Container>
  );
};

export default WorkflowsPage;
